import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { P1, P2, P3 } from 'assets/fonts';
import { Container, Button, TextField } from '@material-ui/core';

const PDF = (props) => {
  const { id } = props;
  const [url, setUrl] = useState("");
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (id) {
      (async () => {
        const doc = await axios.get("/api/gui/pdf/" + id );
        setUrl(doc.data.url);
        setTitle(doc.data.title);
      })();
    }
  }, [id]);

  const handleChange = (e) => {
    const newTitle = e.target.value;
    setTitle(newTitle);
  };

  const handleBlur = async () => {
    await axios.put("/api/gui/pdf/" + id, { title });
  }

  const handleUploadPDF = async () => {
    const doc = await axios.get("/api/gui/pdf");
    const uploadConfigs = doc.data;
    await setUrl(uploadConfigs.key);
    await axios
      .put(uploadConfigs.url, file, {
        headers: {
          "Content-type": 'application/pdf',
        },
      })
      .then(() => window.alert('PDF upload successfully!'))
      .catch((err) => window.alert('PDF upload failed:', err));
    await axios.put("/api/gui/pdf/" + id, { url: uploadConfigs.key });
  }

  return (
    <Container id="icf">
      <P1>PDF</P1>
      <div className="row"><P2 style={{fontWeight: "300"}}>Title: </P2><TextField value={title} onChange={handleChange} onBlur={handleBlur} style={{width: "80%"}}/></div>
      <div className="row">
        <P2 style={{fontWeight: "300"}}>PDF: {url}</P2>
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files[0])}
        />
        <Button size="small" color="primary" variant="outlined" onClick={handleUploadPDF}>Upload</Button>
      </div>
      <br />
    </Container>
  )
};

export default PDF;